/*Mega Menu*/
let items = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");
items.forEach((item) => {
    item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector("summary").setAttribute("aria-expanded", "true");
        item.addEventListener("mouseout", () => {
            item.removeAttribute("open");
            item.querySelector("summary").setAttribute("aria-expanded", "false");
        });
    });
});

/*Hide Show Content*/
let contentexpand = document.querySelector(".homepage .rich-text__text");
if(typeof(contentexpand) != 'undefined' && contentexpand != null){
    let spanlink = document.createElement('span');
    spanlink.innerHTML = "<span class='span-more'>Read More</span><span class='span-less'>Read Less</span>";

    let fragment = document.createDocumentFragment();
    fragment.appendChild(spanlink);

    // attaching click event
    spanlink.addEventListener('click', function () {
        contentexpand.classList.toggle('togglecontent');
    });

    contentexpand.appendChild(fragment);
}

/*Promo Bar */
// Only run if screen is less than 768px
if (window.innerWidth < 768) {
  const promoBars = document.querySelectorAll('.promo-slot');

  promoBars.forEach(promoBar => {
    const messages = promoBar.querySelectorAll('.inner-promo');
    let current = 0;

    // Set the first one active on load
    messages[current].classList.add('active');

    // Rotate every 4 seconds
    setInterval(() => {
      messages[current].classList.remove('active');
      current = (current + 1) % messages.length;
      messages[current].classList.add('active');
    }, 5000);
  });
}

/*Filters*/
document.addEventListener('DOMContentLoaded', function () {
  const facetElement = document.querySelector('.facets-vertical');
  const facetElementLocation = document.querySelector('.facets-vertical-sort');
  const productContainer = document.querySelector('.facets-vertical.page-width');

  if (facetElement) {
    const button = document.createElement('span');
    button.textContent = 'Show Filters';
    button.className = 'open-filters-button';

    button.addEventListener('click', () => {
    button.classList.toggle('is-active');
    productContainer.classList.toggle('filters-visible');

    if(button.classList.contains('is-active')){
      button.textContent = 'Hide Filters'
    } else {
      button.textContent = 'Show Filters'
    };

    });

    facetElementLocation.prepend(button);
  }
});
